
export { IGradientImage } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-consumer-deploy-prod/libs/shared/models/src/lib/imageGradient.models.ts"